import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Snackbar,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import React, { useEffect } from "react";
import { useState } from "react";
import {
  btnStyles,
  dashboarStyles,
  loaderStyles,
  templateCardStyles,
  templateContainerStyles,
  templatePaperStyles,
} from "./TemplatesStyles";
import colors from "../../../Constants/colors";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteBotFromOrg } from "../../../features/organization/orgSlice";
import {
  template_basic_rag,
  template_rag_fqna,
  template_rag_pg,
} from "../../../utils/tempTemplates";
import FileUploadArea from "./FileUploadArea";
import ChatWindow from "./ChatWindow/ChatWindow";
import "./templates.css";

import {
  AGGRESSION_PROMPT,
  COMPLEX_TO_SIMPLE_QUERY_PROMPT,
  HYDE_PROMPT,
  ITERATIVE_DECONSTRUCTION,
  KG_TRIPLET_EXTRACT_TMPL,
  LLAMA_PARSE_PROMPT,
  MULTI_QUERY_PROMPT,
  QUERY_EXPANSION,
  TEXT_TO_NO_SQL_PROMPT,
} from "../../../utils/defaultPrompts";

import {
  deleteBotFromTemplateBots,
  deleteChatbot,
  getBotbyOrgTemplates,
  getCombinations,
} from "../../../features/chatbots/chatbotSlice";
import ApplocationsCard from "./ApplicationsCard/ApplicationsCard";
import { CONTEXTUAL_RETRIEVAL_PROMPT } from "../../../utils/defaultPrompts";
import { Cancel, CheckCircle, Close, InfoOutlined } from "@mui/icons-material";
import { clearDb } from "../../../utils/IndexedDBDexieUtility";
import LLMNode from "../../CreateNewBot/ChatBotRetrievalDocs/RetrievalBot/SubComponents/LLMNode/LLMNode";
import QueryloopNode from "../../CreateNewBot/ChatBotRetrievalDocs/RetrievalBot/SubComponents/RAGHyperparameters/RAGHyperparameters";
import { getReadableTimestamp } from "../../../utils/informationUtility";
import theme, {
  createLLMTypography,
  scrollbarStyles,
  tabsStyle,
} from "../../../Constants/theme";
import { set } from "lodash";
import { iconButtonActive } from "../../../Constants/buttonStyles";
import StatusDot from "../../../Components/StatusDot/StatusDot";

const Templates = ({
  setTabName,
  selectedTemplate,
  setSelectedTemplate,
  setNodeCount,
  initialNodes,
  setElements,
  setBotData: setData,
  setNodeTypesList,
  nodeTypesList,
}) => {
  const organization = useSelector((state) => state.organization);

  // general msgs
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");

  const [templates, setTemplates] = useState([]);
  const [open, setOpen] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [previewData, setPreviewData] = useState({});

  const [generationCombinationId, setGenerationCombinationId] = useState(null);
  const [retrievalCombinationId, setRetrievalCombinationId] = useState(null);
  const [retrievalCombinations, setRetrievalCombinations] = useState(null);
  const [generationCombinationId2, setGenerationCombinationId2] =
    useState(null);
  const [retrievalCombinationId2, setRetrievalCombinationId2] = useState(null);

  const [datasets, setDatasets] = useState([]);
  const [isDragging, setIsDragging] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [loadingGetData, setLoadingGetData] = useState(false);
  const [Bot, setBot] = useState({});
  const [tabValue, setTabValue] = useState(0);
  const [showFileUploadArea, setShowFileUploadArea] = useState(false);

  const [showQuestionnaire, setShowQuestionnaire] = useState(false); // Questionnaire visibility
  const [showOptimizationMessage, setShowOptimizationMessage] = useState(false); // Snackbar visibility
  const [questionnaireMessages, setQuestionnaireMessages] = useState([]); // Questionnaire chat messages
  const [currentQuestion, setCurrentQuestion] = useState(0); // Current question index
  const [questionnaireStarted, setQuestionnaireStarted] = useState(false); // Start questionnaire flag
  const [questionnaireCompleted, setQuestionnaireCompleted] = useState(false); // Questionnaire completion flag
  const [optimizedRag, setOptimizedRag] = useState({
    top_k: 10,
    chunksize: "1800",
    retrieval_method: "sentence-window",
  });
  const [botData, setBotData] = useState({
    organization: "",
    creator: "",
    name: "Template 1",
    problem_statement: "I want a helpful assistant.",
    "llm-finetuning": false,
    datasets: [],
    structured_datasets: [],
    finetuning_dataset: [],
    dynamicShot_dataset: [],
    rqa_prompt: `You are a helpful assistant.`,
    prompt_combinations: { "zero-shot": "You are a helpful assistant." },
    keys: {},
    golden_responses: [],
    golden_responses_option: "generateQna",
    num_of_qa_pairs: 5,
    optimization_method: "grid-search",
    have_memory: true,
    response_length: {
      "detailed-answers": false,
      concise: false,
      "no-preference": true,
    },
    response_length_text: "",
    recency: false,
    recency_text: "",
    tone: { formal: false, informal: false, "no-preference": true },
    tone_text: "",
    latency: { critical: true, noCritical: false },
    references: false,
    references_text: "",
    sources: true,
    sources_text: "\nReturn sources of the documents used in context.",
    metadata_filtering_sub: {
      "all-document-types": false,
      "one-document-type": true,
    },
    metadata_filtering_categories: { "all-equal": true, "not-equal": false },
    metadata_categories: [],
    structured_file: null,
    columnTypes: {},
    metadataDescription: {},
    workflow: {
      retrieval_1: {
        chunksize: {
          300: true,
          700: false,
          1800: true,
          4200: false,
        },
        metric: {
          cosine: true,
          dotproduct: false,
          euclidean: false,
          hybrid: false,
        },
        retrieval_method: {
          basic: true,
          "multi-query": false,
          hyde: false,
          "complex-to-simple-query": false,
          "sentence-window": true,
          "graphrag+basic": false,
          "graphrag+sentence-window": false,
          "graphrag+context_retrieval": false,

          "graphrag+context_retrieval": false,
          "graphrag+sentence-window": false,

          context_retrieval: false,
        },
        rerank_method: {
          none: true,
          mmr: false,
          cohere: false,
          llm_rerank: false,
          pinecone: false,
          jina: false,
          nvidia: false,
          contextualai: false,
          llamarank: false,
        },
        top_k: {
          1: false,
          5: true,
          10: true,
          15: false,
          20: false,
          25: false,
          30: false,
          35: false,
          40: false,
        },
        embedding_model: {
          "text-embedding-ada-002": true,
          "fine-tuned": false,
          "text-embedding-3-small": false,
          "text-embedding-3-large": false,
          "voyage-law-2": false,
          "voyage-finance-2": false,
          "voyage-code-3": false,
          "voyage-3.5": false,
          "embed-v4.0": false,
        },
        parser: {
          recursive_character_text_splitter: true,
          unstructuredio: false,
          llama_parse: false,
        },
        query_preprocess_method: {
          basic: true,
          multi_query: false,
          hyde: false,
          complex_to_simple: false,
          query_expansion: false,
          iterative_deconstruction: false,
        },
        metadata_filtering: { "add-metadata": false, "no-metadata": true },
        applications: {
          "no-application": true,
          slack: false,
          telegram: false,
          googledrive: false,
        },
        tools: {
          "no-tools": true,
          calendly: false,
          traditionalDb: false,
          "payment-system": false,
        },
        knowledgebase: {
          "no-knowledgebase": true,
          csv: false,
          websites: false,
          drive: false,
        },
      },
      generation_1: {
        finetuning_values: {
          llm: { "llama-3-8b": false, "gpt-4o-mini-2024-07-18": true },
          epoch: { 1: true },
          learningRate: { 1: "true" },
          batchSize: { 2: "true" },
          optimization_method: "grid-search",
          prompts: {
            "zero-shot": true,
            "few-shot": false,
            "few-shot-random": false,
            "dynamic-few-shot": false,
            "chain-of-thought": false,
            "few-shot-cot-random": false,
          },
        },
        llm_params: {
          temperature: { 0: "true" },
          outputTokenLimit: { 0: "true" },
          llm: {
            "gpt-4o-mini": true,
            "gpt-4": false,
            "gpt-4o": false,
            "meta-llama/Meta-Llama-3-8B-Instruct-Turbo": false,
            "meta-llama/Meta-Llama-3.1-8B-Instruct-Turbo": false,
            "meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo": false,
            "meta-llama/Llama-3.2-11B-Vision-Instruct-Turbo": false,
            "meta-llama/Llama-3.2-90B-Vision-Instruct-Turbo": false,
            "meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8": false,
            "meta-llama/Llama-4-Scout-17B-16E-Instruct": false,
            "claude-3-opus-20240229": false,
            "claude-3-sonnet-20240229": false,
            "claude-3-haiku-20240307": false,
            "claude-3-5-sonnet-20241022": false,
            "gemini-1.5-pro": false,
            "gemini-1.5-flash": false,
            "gemini-1.0-pro": false,
            "gemini-2.5-flash-preview-05-20": false,
            "mistralai/Mixtral-8x22B-Instruct-v0.1": false,
            "mistralai/Mixtral-8x7B-Instruct-v0.1": false,
            "claude-sonnet-4-20250514": false,
            "claude-opus-4-20250514": false,
            o1: false,
            "o1-mini": false,
            "gpt-4.1-2025-04-14": false,
            "gpt-4.1-mini-2025-04-14": false,
            "gpt-4.1-nano-2025-04-14": false,
            "gemini-1.5-flash-8b": false,
            "meta-llama/Llama-3.3-70B-Instruct-Turbo": false,
            "deepseek-ai/DeepSeek-V3": false,
            "deepseek-ai/deepseek-llm-67b-chat": false,
            "grok-3-latest": false,
            "grok-3-fast-latest": false,
            "grok-3-mini-latest": false,
            "grok-3-mini-fast-latest": false,
            "Qwen/Qwen3-235B-A22B-fp8-tput": false,
          },
          prompts: {
            "zero-shot": true,
            "few-shot": false,
            "few-shot-random": false,
            "dynamic-few-shot": false,
            "chain-of-thought": false,
            "few-shot-cot-random": false,
          },
        },
      },
    },
    headers: [],
    foundational: true,
    unstructuredColumnTypes: {},
    query_preprocessing_prompts: {
      retrieval_1: {
        complex_to_simple: COMPLEX_TO_SIMPLE_QUERY_PROMPT,
        query_expansion: QUERY_EXPANSION,
        multi_query: MULTI_QUERY_PROMPT,
        hyde: HYDE_PROMPT,
        iterative_deconstruction: ITERATIVE_DECONSTRUCTION,
      },
    },
    neo4j_credentials: {
      NEO4J_URI: "",
      NEO4J_USERNAME: "",
      NEO4J_PASSWORD: "",
      llm: "",
    },
    neo_4j_prompts: {
      KG_TRIPLET_EXTRACT_TMPL: KG_TRIPLET_EXTRACT_TMPL,
    },
    retrieval_prompts: {
      contextual_retrieval_prompt: "",
      chunk_window_size: "2",
    },
    text2nosql_prompt: {
      TEXT_TO_NO_SQL_PROMPT: TEXT_TO_NO_SQL_PROMPT,
    },
    text2nosql: false,
    "text2nosql-vectorsearch": true,
    aggregation_prompt: AGGRESSION_PROMPT,
    parsing_instructions: {
      llama_parse_prompt: LLAMA_PARSE_PROMPT,
      llama_parse_mode: {
        accurate: false,
        premium: false,
        continuous: false,
        third_party_multimodal: false,
        auto: true,
      },
      third_party_multimodal_llm: {
        llm: "",
      },
      exclude_title_page: false,
      bounding_box: "0,0,0,0",
      title_page_number: "1",
      unstructuredio_mode: {
        fast: false,
        hi_res: false,
        auto: true,
        ocr_only: false,
      },
    },
    templates: true,
  });

  const chatbot = useSelector((state) => state.chatbot);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [laodingDelete, setLoadingDelete] = useState(false);

  useEffect(() => {
    const fetchTemplates = async () => {
      const orgId = organization?.organization?._id?.["$oid"];
      if (organization?.templatesData?.length < 1) {
        // set templates
        setTemplates([template_basic_rag, template_rag_pg, template_rag_fqna]);
      }
    };

    fetchTemplates(); // Call the async function inside useEffect
  }, [organization]);

  useEffect(() => {
    const getData = async () => {
      setLoadingGetData(true);
      const response = await dispatch(
        getBotbyOrgTemplates(organization?.organization?._id["$oid"])
      );
      if (response?.payload?.combinations?.length === 0) {
        localStorage.setItem("reqCount", 2);
      }
      const bot = await response?.payload?.combinations?.[
        response?.payload?.combinations?.length - 1
      ];
      setBot({ ...bot });

      setTimeout(() => {
        setLoadingGetData(false);
      }, 200);

      if (bot?.combinations?.length > 1) {
        setBotData((prevData) => ({
          ...prevData,
          retrieval_prompts: {
            contextual_retrieval_prompt: CONTEXTUAL_RETRIEVAL_PROMPT,
            chunk_window_size: "2",
          },
          text2nosql_prompt: {
            TEXT_TO_NO_SQL_PROMPT: TEXT_TO_NO_SQL_PROMPT,
          },
          text2nosql: false,
          "text2nosql-vectorsearch": true,
          aggregation_prompt: AGGRESSION_PROMPT,
          workflow: {
            ...prevData.workflow,
            retrieval_1: {
              ...prevData.workflow.retrieval_1,
              chunksize: {
                ...prevData.workflow.retrieval_1.chunksize,
                1800: true,
              },
              top_k: {
                ...prevData.workflow.retrieval_1.top_k,
                10: true,
              },
              retrieval_method: {
                ...prevData.workflow.retrieval_1.retrieval_method,
                "sentence-window": true,
              },
            },
          },
        }));

        const responseRetrievalCombination = await dispatch(
          getCombinations({
            id: bot?._id["$oid"],
            items: 100,
            from: 0,
            data: {},
          })
        );

        const retrievalCombinations =
          responseRetrievalCombination.payload.combinations;
        if (
          !organization?.organization?.optimizedCombinations[
            bot?._id["$oid"]
          ] &&
          Object.keys(optimizedRag).length > 2
        ) {
          const __OPTIMIZED__BOT__COMBINATION__ = getMatchingCombinationId(
            optimizedRag,
            retrievalCombinations
          );
          setRetrievalCombinationId2(__OPTIMIZED__BOT__COMBINATION__);
          setLoadingGetData(false);
        } else {
          setRetrievalCombinationId2(
            organization?.organization?.optimizedCombinations[bot?._id["$oid"]]
          );
          setLoadingGetData(false);
        }
        setRetrievalCombinations(retrievalCombinations);
        setRetrievalCombinationId(bot?.combinations?.[0]?.["$oid"]);
        setLoadingGetData(false);
      }

      if (bot?.generation_combinations?.length > 0) {
        setGenerationCombinationId(bot?.generation_combinations?.[0]?.["$oid"]);
        setGenerationCombinationId2(
          bot?.generation_combinations?.[1]?.["$oid"]
        );
        setLoadingGetData(false);
      }

      function getMatchingCombinationId(optimizedRag, combinations) {
        const optimizedKeys = Object.keys(optimizedRag);

        for (const combination of combinations) {
          const isMatch = optimizedKeys.every((key) => {
            if (optimizedRag[key]) {
              return combination[key] === optimizedRag[key];
            }
            return combination[key] === optimizedRag[key];
          });
          if (isMatch) {
            return combination._id["$oid"];
          }
        }

        // If no match is found, return null
        return null; //combinations[combinations.length - 1]._id["$oid"];
      }
    };

    if (
      !chatbot?.isLoading &&
      !loading &&
      !showFileUploadArea &&
      organization?.organization?.templates?.length > 0 &&
      Object.keys(Bot).length === 0 &&
      localStorage.getItem("reqCount") < 1
    ) {
      if (!showFileUploadArea) {
        getData();
      }
    }
  }, [organization, chatbot]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (loading || loadingGetData) {
        e.preventDefault();

        e.returnValue =
          "Are you sure you want to leave? Your changes may not be saved and application creation or optimization may fail.";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [loading, loadingGetData]);

  const handleTabChangeTemplate = (event, newValue) => {
    if (newValue === 2) {
      navigate("/dashboard/createChatbot");
      setTabName("createChatbot");
      return;
    }
    setTabValue(newValue);
  };

  const handleOptimizeFurther = () => {
    setNodeTypesList({
      ...nodeTypesList,
      QueryloopNode: QueryloopNode,
      llm: LLMNode,
    });
    const newDatasets = (Bot?.datasets?.retrieval_1 || []).map(
      (__DATA__, index) => ({
        fileName: __DATA__?.file_name?.split("/")[2],
        confidentiality: "Public",
        fileSize: __DATA__?.fileSize,
        fileType: __DATA__?.fileType,
        id: __DATA__?.id,
      })
    );
    let updatedData = {
      ...botData,

      name: Bot?.name.split("_")[0] + "_" + getReadableTimestamp(),
      get_dataset_from_bot: Bot?._id["$oid"],
      datasets: newDatasets,
      csvData: {},
      column_types: {},
      structured_file: {},
      combination_settings: botData.workflow.retrieval_1,
      generation_settings: botData.workflow.generation_1,
      golden_responses: Bot?.golden_responses || [],
      golden_responses_option: Bot?.golden_responses
        ? "userQna"
        : "generateQna",
      num_of_qa_pairs: Bot?.num_of_qa_pairs,
      aggregation_prompt: Bot?.aggregation_prompt,
      prompt_combinations: Bot?.prompt_combinations,
      prompt_guidelines: Bot?.prompt_guidelines,
    };
    delete updatedData.workflow;
    setData({
      ...updatedData,
    });
    setSelectedTemplate(updatedData);

    navigate("/dashboard/createChatbot");
    setTabName("createChatbot");
  };
  const handleOptimizeNow = async () => {
    // if a starts an optimization process and leaves the page then comes back to it then user sees unoptimized bot only
    // even though the optimization process is still running in the background.
    // If the user tries to optimize the bot again then user will endup creating 2 optimized bots for the same unoptimized bot.
    // This error will be faced by starter and pro users, this is a temporary fix for starter users only.
    if (organization?.organization?.subscription === "starter") {
      const orgId = organization?.organization?._id?.["$oid"];
      const responseGetBotOrgTemplates = await dispatch(
        getBotbyOrgTemplates(orgId)
      );
      const bots_list = responseGetBotOrgTemplates?.payload?.combinations || [];
      if (bots_list.length > 1) {
        //find only initialised === "initialising" bots
        const initialisingBots = bots_list.filter(
          (bot) => bot.initialised === "initialising"
        );
        const initialisedBots = bots_list.filter(
          (bot) => bot.initialised === "initialised"
        );
        const notStartedBots = bots_list.filter(
          (bot) => bot.initialised === "not started"
        );
        // if initialised bots are more than 1, then show alert
        if (initialisingBots.length > 0 || notStartedBots.length > 0) {
          alert(
            "You have already started an optimization process. Please wait."
          );
          setLoading(false);
          setLoadingMessage("");
          return;
        } else if (initialisedBots.length > 1) {
          alert(
            "Previously started optimization is now complete please reload the application."
          );
          setLoading(false);
          setLoadingMessage("");

          return;
        }
      }
    }
    setBotData((prevData) => ({
      ...prevData,
      name: Bot?.name.split("_")[0] + "_" + getReadableTimestamp(),
      retrieval_prompts: {
        contextual_retrieval_prompt: CONTEXTUAL_RETRIEVAL_PROMPT,
        chunk_window_size: "2",
      },
      text2nosql: false,
      "text2nosql-vectorsearch": true,
      text2nosql_prompt: {
        TEXT_TO_NO_SQL_PROMPT: TEXT_TO_NO_SQL_PROMPT,
      },
      aggregation_prompt: AGGRESSION_PROMPT,
      golden_responses: Bot?.golden_responses || [],
      golden_responses_option:
        Bot?.golden_responses?.length > 0 ? "userQna" : "generateQna",
      num_of_qa_pairs: 5,
      workflow: {
        ...prevData.workflow,
        retrieval_1: {
          ...prevData.workflow.retrieval_1,
          chunksize: {
            ...prevData.workflow.retrieval_1.chunksize,
            1800: true,
          },
          top_k: {
            ...prevData.workflow.retrieval_1.top_k,
            10: true,
          },
          retrieval_method: {
            ...prevData.workflow.retrieval_1.retrieval_method,
            "sentence-window": true,
          },
        },
      },
    }));
    setOptimizedRag({
      top_k: 10,
      chunksize: "1800",
      retrieval_method: "sentence-window",
    });
    setShowQuestionnaire(true);
    setShowOptimizationMessage(false); // Reset questionnaire state if reopened
    setCurrentQuestion(0); // Reset question index
    setQuestionnaireMessages([]); // Clear previous messages
    setQuestionnaireStarted(true);
    setQuestionnaireCompleted(false);
  };
  const handleDelete = async (id) => {
    setBotData({
      organization: "",
      creator: "",
      name: "Template 1",
      problem_statement: "I want a helpful assistant.",
      "llm-finetuning": false,
      datasets: [],
      structured_datasets: [],
      finetuning_dataset: [],
      dynamicShot_dataset: [],
      rqa_prompt: `You are a helpful assistant.`,
      prompt_combinations: { "zero-shot": "You are a helpful assistant." },
      keys: {},
      golden_responses: [],
      golden_responses_option: "generateQna",
      num_of_qa_pairs: 5,
      optimization_method: "grid-search",
      have_memory: true,
      response_length: {
        "detailed-answers": false,
        concise: false,
        "no-preference": true,
      },
      response_length_text: "",
      recency: false,
      recency_text: "",
      tone: { formal: false, informal: false, "no-preference": true },
      tone_text: "",
      latency: { critical: true, noCritical: false },
      references: false,
      references_text: "",
      sources: true,
      sources_text: "\nReturn sources of the documents used in context.",
      metadata_filtering_sub: {
        "all-document-types": false,
        "one-document-type": true,
      },
      metadata_filtering_categories: { "all-equal": true, "not-equal": false },
      metadata_categories: [],
      structured_file: null,
      columnTypes: {},
      metadataDescription: {},
      workflow: {
        retrieval_1: {
          chunksize: {
            300: true,
            700: false,
            1800: true,
            4200: false,
          },
          metric: {
            cosine: true,
            dotproduct: false,
            euclidean: false,
            hybrid: false,
          },
          retrieval_method: {
            basic: true,
            "multi-query": false,
            hyde: false,
            "complex-to-simple-query": false,
            "sentence-window": true,
            "graphrag+basic": false,
            "graphrag+sentence-window": false,
            "graphrag+context_retrieval": false,

            "graphrag+context_retrieval": false,
            "graphrag+sentence-window": false,

            context_retrieval: false,
          },
          rerank_method: {
            none: true,
            mmr: false,
            cohere: false,
            llm_rerank: false,
            pinecone: false,
            jina: false,
            nvidia: false,
            contextualai: false,
            llamarank: false,
          },
          top_k: {
            1: false,
            5: true,
            10: true,
            15: false,
            20: false,
            25: false,
            30: false,
            35: false,
            40: false,
          },
          embedding_model: {
            "text-embedding-ada-002": true,
            "fine-tuned": false,
            "text-embedding-3-small": false,
            "text-embedding-3-large": false,
            "voyage-law-2": false,
            "voyage-finance-2": false,
            "voyage-code-3": false,
            "voyage-3.5": false,
            "embed-v4.0": false,
          },
          parser: {
            recursive_character_text_splitter: true,
            unstructuredio: false,
            llama_parse: false,
          },
          query_preprocess_method: {
            basic: true,
            multi_query: false,
            hyde: false,
            complex_to_simple: false,
            query_expansion: false,
            iterative_deconstruction: false,
          },
          metadata_filtering: { "add-metadata": false, "no-metadata": true },
          applications: {
            "no-application": true,
            slack: false,
            telegram: false,
            googledrive: false,
          },
          tools: {
            "no-tools": true,
            calendly: false,
            traditionalDb: false,
            "payment-system": false,
          },
          knowledgebase: {
            "no-knowledgebase": true,
            csv: false,
            websites: false,
            drive: false,
          },
        },
        generation_1: {
          finetuning_values: {
            llm: { "llama-3-8b": false, "gpt-4o-mini-2024-07-18": true },
            epoch: { 1: true },
            learningRate: { 1: "true" },
            batchSize: { 2: "true" },
            optimization_method: "grid-search",
            prompts: {
              "zero-shot": true,
              "few-shot": false,
              "few-shot-random": false,
              "dynamic-few-shot": false,
              "chain-of-thought": false,
              "few-shot-cot-random": false,
            },
          },
          llm_params: {
            temperature: { 0: "true" },
            outputTokenLimit: { 0: "true" },
            llm: {
              "gpt-4o-mini": true,
              "gpt-4": false,
              "gpt-4o": false,
              "meta-llama/Meta-Llama-3-8B-Instruct-Turbo": false,
              "meta-llama/Meta-Llama-3.1-8B-Instruct-Turbo": false,
              "meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo": false,
              "meta-llama/Llama-3.2-11B-Vision-Instruct-Turbo": false,
              "meta-llama/Llama-3.2-90B-Vision-Instruct-Turbo": false,
              "meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8": false,
              "meta-llama/Llama-4-Scout-17B-16E-Instruct": false,
              "claude-3-opus-20240229": false,
              "claude-3-sonnet-20240229": false,
              "claude-3-haiku-20240307": false,
              "claude-3-5-sonnet-20241022": false,
              "gemini-1.5-pro": false,
              "gemini-1.5-flash": false,
              "gemini-1.0-pro": false,
              "gemini-2.5-flash-preview-05-20": false,
              "mistralai/Mixtral-8x22B-Instruct-v0.1": false,
              "mistralai/Mixtral-8x7B-Instruct-v0.1": false,
              "claude-sonnet-4-20250514": false,
              "claude-opus-4-20250514": false,
              o1: false,
              "o1-mini": false,
              "gpt-4.1-2025-04-14": false,
              "gpt-4.1-mini-2025-04-14": false,
              "gpt-4.1-nano-2025-04-14": false,
              "gemini-1.5-flash-8b": false,
              "meta-llama/Llama-3.3-70B-Instruct-Turbo": false,
              "deepseek-ai/DeepSeek-V3": false,
              "deepseek-ai/deepseek-llm-67b-chat": false,
              "grok-3-latest": false,
              "grok-3-fast-latest": false,
              "grok-3-mini-latest": false,
              "grok-3-mini-fast-latest": false,
              "Qwen/Qwen3-235B-A22B-fp8-tput": false,
            },
            prompts: {
              "zero-shot": true,
              "few-shot": false,
              "few-shot-random": false,
              "dynamic-few-shot": false,
              "chain-of-thought": false,
              "few-shot-cot-random": false,
            },
          },
        },
      },
      headers: [],
      foundational: true,
      unstructuredColumnTypes: {},
      query_preprocessing_prompts: {
        retrieval_1: {
          complex_to_simple: COMPLEX_TO_SIMPLE_QUERY_PROMPT,
          query_expansion: QUERY_EXPANSION,
          multi_query: MULTI_QUERY_PROMPT,
          hyde: HYDE_PROMPT,
          iterative_deconstruction: ITERATIVE_DECONSTRUCTION,
        },
      },
      neo4j_credentials: {
        NEO4J_URI: "",
        NEO4J_USERNAME: "",
        NEO4J_PASSWORD: "",
        llm: "",
      },
      neo_4j_prompts: {
        KG_TRIPLET_EXTRACT_TMPL: KG_TRIPLET_EXTRACT_TMPL,
      },
      retrieval_prompts: {
        contextual_retrieval_prompt: "",
        chunk_window_size: "2",
      },
      text2nosql_prompt: {
        TEXT_TO_NO_SQL_PROMPT: TEXT_TO_NO_SQL_PROMPT,
      },
      text2nosql: false,
      "text2nosql-vectorsearch": true,
      aggregation_prompt: AGGRESSION_PROMPT,
      parsing_instructions: {
        llama_parse_prompt: LLAMA_PARSE_PROMPT,
        llama_parse_mode: {
          accurate: false,
          premium: false,
          continuous: false,
          third_party_multimodal: false,
          auto: true,
        },
        third_party_multimodal_llm: {
          llm: "",
        },
        exclude_title_page: false,
        bounding_box: "0,0,0,0",
        title_page_number: "1",
        unstructuredio_mode: {
          fast: false,
          hi_res: false,
          auto: true,
          ocr_only: false,
        },
      },
      templates: true,
    });
    setDatasets([]);
    setLoadingDelete(true);
    setShowQuestionnaire(false);
    const response = await dispatch(deleteChatbot(id));
    const responseDelete = await dispatch(
      getBotbyOrgTemplates(organization.organization._id["$oid"])
    );
    await dispatch(deleteBotFromOrg(id));
    await dispatch(deleteBotFromTemplateBots(id));
    if (Bot?._id?.["$oid"] === id) {
      setBot({});
      setShowFileUploadArea(true);
      setDatasets([]);
    }
    setLoadingDelete(false);
  };
  const items = [
    {
      title: "Quick Start: Basic Chat App",
      description: {
        summary: "Set up a basic app with default settings.",
        parameters: [
          {
            name: "Settings: Preconfigured for text processing and AI generation.",
            status: true,
          },
          { name: "Dataset: Upload your own documents.", status: false },
          {
            name: "Sample QnAs: Provide your own examples and ideal answers.",
            status: false,
          },
        ],
      },
      bot_id: "template_basic_rag",
      overview: (
        <div>
          <p>
            This template creates a basic Retrieval-Augmented Generation (RAG)
            application with default settings, ready for immediate use.
          </p>
          <p>No dataset is included, allowing you to add your own as needed.</p>
        </div>
      ),
      retrieval: (
        <div style={{ fontSize: "0.9em" }}>
          <p>
            <strong>Retrieval settings Overview:</strong>
          </p>
          <p>
            Default retrieval settings include basic settings for managing and
            retrieving information from datasets.
          </p>
          <p>
            These settings define text segmentation and retrieval processes,
            offering a starting point for custom configurations.
          </p>
          <ul>
            <li>
              <strong>Chunk Size:</strong> Default chunk size set for
              general-purpose retrieval.
            </li>
            <li>
              <strong>Similarity Metric:</strong> Basic cosine similarity to
              measure relevance.
            </li>
            <li>
              <strong>Retrieval Method:</strong> Standard retrieval without
              advanced techniques.
            </li>
            <li>
              <strong>Re-ranking Method:</strong> None.
            </li>
            <li>
              <strong>Top-K:</strong> Retrieves top 5 documents by default.
            </li>
            <li>
              <strong>Embedding Model:</strong> Text-Embedding-Ada-002 as the
              default embedding model.
            </li>
          </ul>
        </div>
      ),
      generation: (
        <div style={{ fontSize: "0.9em" }}>
          <p>
            Default generation settings demonstrate basic configurations for LLM
            applications.
          </p>
          <ul>
            <li>
              <strong>Language Model (llm):</strong> gpt-4o-mini, set for
              general text generation tasks.
            </li>
            <li>
              <strong>Temperature:</strong> Configured at 1, balancing
              creativity and focus.
            </li>
            <li>
              <strong>Output Token Limit:</strong> Set to 0, with no cap on
              response length.
            </li>
            <li>
              <strong>Prompts:</strong>
              <ul>
                <li>
                  <strong>Zero-Shot:</strong> Default for generating outputs
                  without prior examples.
                </li>
              </ul>
            </li>
          </ul>
        </div>
      ),
      dataset: (
        <div style={{ color: "white" }}>
          <p>
            No dataset is included in this template. Users are encouraged to
            upload their own datasets for customization.
          </p>
        </div>
      ),
      benchmarks: (
        <div style={{ fontSize: "0.9em", color: "white" }}>
          <p>
            <strong>No sample questions & answers</strong> are included in this
            template. Users can upload their own sample questions & answers to
            evaluate application performance.
          </p>
        </div>
      ),
    },
    {
      title: "Chat over Paul Graham Essays",
      description: {
        summary: "Dive into text files and analyze them with ease.",
        parameters: [
          {
            name: "Settings: Configured with both standard and alternative options.",
            status: true,
          },
          {
            name: "Dataset: Paul Graham essays",
            status: true,
          },
          {
            name: "Sample QnAs: Preloaded sample questions and answers.",
            status: true,
          },
        ],
      },
      bot_id: "template_rag_pg",
      overview: (
        <div>
          <p>
            This template is designed for building a Retrieval-Augmented
            Generation (RAG) app that processes text files such as essays.
          </p>
          <p>Paul Graham's essays are included in .txt format.</p>
          <p>
            Benchmark answers are added to help in evaluating the app's accuracy
            and response quality.
          </p>
        </div>
      ),
      retrieval: (
        <div style={{ fontSize: "0.9em" }}>
          <p>
            <strong>Retrieval settings Overview:</strong>
          </p>
          <p>
            Retrieval settings include a mix of optimal and sub-optimal
            settings, showcasing their impact on LLM performance and offering
            insights into strengths and weaknesses.
          </p>
          <p>
            These settings define how text is segmented, compared, and
            retrieved, highlighting key aspects of retrieval performance.
          </p>
          <p>
            Queryloop accelerates this process by helping you identify the
            optimal configuration in the shortest possible time, ensuring
            efficient and effective results for your application.
          </p>

          <ul>
            <li>
              <strong>Chunk Size:</strong>
              <p>
                Chunking divides long text into smaller, manageable segments to
                balance detail and context. Selected options:
              </p>
              <ul>
                <li>
                  <strong>Tiny:</strong> Captures precise, fine-grained
                  information.
                </li>
                <li>
                  <strong>Medium:</strong> Maintains a broader view while
                  preserving some detail.
                </li>
              </ul>
            </li>
            <li>
              <strong>Similarity Metric:</strong>
              <p>
                Specifies the method for comparing text embeddings to measure
                relevance. Enabled metrics include:
              </p>
              <ul>
                <li>
                  <strong>Cosine Similarity:</strong> Measures the cosine of the
                  angle between two vectors, reflecting their orientation
                  similarity.
                </li>
              </ul>
            </li>
            <li>
              <strong>Retrieval Method:</strong>
              <p>
                Defines strategies for retrieving documents. Enabled methods
                are:
              </p>
              <ul>
                <li>
                  <strong>Basic:</strong> Standard retrieval without advanced
                  preprocessing.
                </li>
                <li>
                  <strong>Chunk Window:</strong> Vectorizes chunks while
                  tracking adjacent ones, appending them during retrieval to
                  provide contextual coherence and enhance comprehension.
                </li>
              </ul>
            </li>
            <li>
              <strong>Re-ranking Method:</strong>
              <p>
                Adjusts the ranking of retrieved documents based on additional
                evaluation. Enabled methods are:
              </p>
              <ul>
                <li>
                  <strong>None:</strong> No re-ranking is applied to the
                  retrieved documents.
                </li>
                <li>
                  <strong>Cohere Re-rank:</strong> Uses a cross-encoder to
                  reorder results by analyzing query-document interactions for
                  better contextual relevance.
                </li>
              </ul>
            </li>
            <li>
              <strong>Top-K:</strong>
              <p>
                Specifies the number of top documents to retrieve. Enabled
                values are 5 and 15, ensuring a focus on the most relevant
                content.
              </p>
            </li>
            <li>
              <strong>Embedding Model:</strong>
              <p>
                The model used to generate embeddings for text. The selected
                model is:
              </p>
              <ul>
                <li>
                  <strong>Text-Embedding-Ada-002:</strong> A robust model
                  optimized for high-quality text embeddings.
                </li>
              </ul>
            </li>
          </ul>
        </div>
      ),
      generation: (
        <div>
          <p>
            Generation settings include a mix of optimal and sub-optimal
            settings to demonstrate how different configurations impact LLM
            application performance.
          </p>
          <p>
            Queryloop helps you get to the optimal configuration in the shortest
            possible time
          </p>
          <ul>
            <li>
              <li>
                <strong>Language Model (llm):</strong> The selected model is{" "}
                <em>gpt-4o-mini</em>, tuned for efficient text generation.
              </li>
              <strong>Temperature:</strong> Configured at 0, for precise,
              fact-based, and consistent answers.
            </li>
            <li>
              <strong>Output Token Limit:</strong> Set to 0, meaning there is no
              explicit cap on the number of tokens generated per response.
            </li>

            <li>
              <strong>Prompts:</strong>
              <ul>
                <li>
                  <strong>Zero-Shot:</strong> Generating outputs without prior
                  examples.
                </li>
                <li>
                  <strong>Chain-of-Thought:</strong> Producing responses with a
                  structured reasoning approach.
                </li>
              </ul>
            </li>
          </ul>
        </div>
      ),
      dataset: (
        <div style={{ color: "white" }}>
          <p>
            The dataset includes essays from Paul Graham in various formats to
            analyze and answer questions effectively.
          </p>
          <ul>
            <li>
              <strong>Textual Content:</strong> Essays written by Paul Graham,
              covering a wide range of topics.
            </li>
            <li>
              <strong>Formats:</strong> Available in .txt format for efficient
              parsing.
            </li>
            <li>
              <strong>Accessibility:</strong>{" "}
              <a
                href="https://github.com/TonicAI/tonic_validate/tree/main/examples/paul_graham_essays"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Dataset
              </a>
            </li>
          </ul>
        </div>
      ),
      benchmarks: (
        <div style={{ fontSize: "0.9em" }}>
          <p style={{ color: "white" }}>
            <strong>The sample questions </strong> include 5 questions selected
            from the json file &nbsp;
            <a
              href="https://github.com/TonicAI/tonic_validate/blob/main/examples/question_and_answer_list.json"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white" }}
            >
              <code>question_and_answer_list.json</code>
            </a>
            &nbsp; related to 5 selected essays from Paul Graham essays dataset.
          </p>

          <p>Each entry includes:</p>
          <ul>
            <li>A question</li>
            <li>The corresponding answer</li>
          </ul>
          <p>
            This structured format facilitates the evaluation of retrieval and
            generation models by providing a clear mapping between queries and
            expected responses.
          </p>
        </div>
      ),
    },
    {
      title: "Chat over Apple Financials",
      description: {
        summary: "Easily process PDFs containing tabular data.",
        parameters: [
          {
            name: "Settings: Configured with both standard and alternative options.",
            status: true,
          },
          {
            name: "Dataset: Structured financial reports of Apple",
            status: true,
          },
          {
            name: "Sample QnAs: Preloaded sample questions and answers.",
            status: true,
          },
        ],
      },
      bot_id: "template_rag_fqna",
      overview: (
        <div>
          <p>
            This template enables you to create a Retrieval-Augmented Generation
            (RAG) application tailored for PDFs containing tabular data.
          </p>

          <p>A financial dataset use case</p>
          <p>
            Benchmark answers are provided to evaluate the performance of the
            app in extracting and reasoning over tabular data.
          </p>
        </div>
      ),
      retrieval: (
        <div style={{ fontSize: "0.9em" }}>
          <p>
            <strong>Retrieval settings Overview:</strong>
          </p>
          <p>
            Retrieval settings include a mix of optimal and sub-optimal
            settings, showcasing their impact on LLM performance and offering
            insights into strengths and weaknesses.
          </p>
          <p>
            These settings define how text is segmented, compared, and
            retrieved, highlighting key aspects of retrieval performance.
          </p>
          <p>
            Queryloop accelerates this process by helping you identify the
            optimal configuration in the shortest possible time, ensuring
            efficient and effective results for your application.
          </p>

          <ul>
            <li>
              <strong>Chunk Size:</strong>
              <p>
                Chunking divides long text into smaller, manageable segments to
                balance detail and context. Selected options:
              </p>
              <ul>
                <li>
                  <strong>Tiny (300 characters):</strong> Captures precise,
                  fine-grained information.
                </li>
                <li>
                  <strong>Medium (1800 characters):</strong> Maintains a broader
                  view while preserving some detail.
                </li>
              </ul>
            </li>
            <li>
              <strong>Similarity Metric (metric):</strong>
              <p>
                Specifies the method for comparing text embeddings to measure
                relevance. Enabled metrics include:
              </p>
              <ul>
                <li>
                  <strong>Cosine Similarity (cosine):</strong> Measures the
                  cosine of the angle between two vectors, reflecting their
                  orientation similarity.
                </li>
              </ul>
            </li>
            <li>
              <strong>Retrieval Method (retrieval_method):</strong>
              <p>
                Defines strategies for retrieving documents. Enabled methods
                are:
              </p>
              <ul>
                <li>
                  <strong>Basic (basic):</strong> Standard retrieval without
                  advanced preprocessing.
                </li>
                <li>
                  <strong>Context Retrieval (context_retrieval):</strong>{" "}
                  Incorporates surrounding text to improve relevance during
                  retrieval.
                </li>
              </ul>
            </li>
            <li>
              <strong>Re-ranking Method (rerank_method):</strong>
              <p>
                Adjusts the ranking of retrieved documents based on additional
                evaluation. Enabled methods are:
              </p>
              <ul>
                <li>
                  <strong>None (none):</strong> No re-ranking is applied to the
                  retrieved documents.
                </li>
                <li>
                  <strong>LLM Re-rank (llm_rerank):</strong> Uses a Large
                  Language Model to re-rank documents for improved semantic
                  relevance.
                </li>
              </ul>
            </li>
            <li>
              <strong>Top-K (top_k):</strong>
              <p>
                Specifies the number of top documents to retrieve. Enabled
                values are 10 and 20, ensuring a focus on the most relevant
                content.
              </p>
            </li>
            <li>
              <strong>Embedding Model (embedding_model):</strong>
              <p>
                The model used to generate embeddings for text. The selected
                model is:
              </p>
              <ul>
                <li>
                  <strong>
                    Text-Embedding-Ada-002 (text-embedding-ada-002):
                  </strong>{" "}
                  A robust model optimized for high-quality text embeddings.
                </li>
              </ul>
            </li>
          </ul>
        </div>
      ),
      generation: (
        <div style={{ fontSize: "0.9em" }}>
          <p>
            Generation settings include a mix of optimal and sub-optimal
            settings to demonstrate how different configurations impact LLM
            application performance.
          </p>
          <p>
            Queryloop helps you get to the optimal configuration in the shortest
            possible time
          </p>
          <ul>
            <li>
              <li>
                <strong>Language Model (llm):</strong> The selected model is{" "}
                <em>gpt-4o-mini</em>, tuned for efficient text generation.
              </li>
              <strong>Temperature:</strong> Configured at 0, for precise,
              fact-based, and consistent answers.
            </li>
            <li>
              <strong>Output Token Limit:</strong> Set to 0, meaning there is no
              explicit cap on the number of tokens generated per response.
            </li>

            <li>
              <strong>Prompts:</strong>
              <ul>
                <li>
                  <strong>Zero-Shot:</strong> Generating outputs without prior
                  examples.
                </li>
                <li>
                  <strong>Chain-of-Thought:</strong> Producing responses with a
                  structured reasoning approach.
                </li>
              </ul>
            </li>
          </ul>
        </div>
      ),
      dataset: (
        <div>
          <p>
            The dataset's PDF file format represents SEC 10-Q filings from
            Apple. These files are structured financial documents that include
            sections like financial statements, management discussion and
            analysis, and risk factors. The PDFs often contain:
          </p>
          <ul>
            <li>
              <strong>Textual Content:</strong> Narrative descriptions of
              financial performance, strategic updates, and operational
              highlights.
            </li>
            <li>
              <strong>Tabular Data:</strong> Detailed tables presenting
              financial metrics such as revenue, expenses, and net income across
              reporting periods.
            </li>
            <li>
              <strong>Headers and Footers:</strong> Standardized formatting with
              company identifiers, dates, and page numbers.
            </li>
            <li>
              <strong>Embedded Metadata:</strong> Data embedded in the PDF, such
              as authorship and creation details, which may assist in document
              processing.
            </li>
            <li>
              <strong>Complex Layouts:</strong> Multicolumn layouts, charts, and
              graphs to visualize key metrics and trends.
            </li>
          </ul>
          <p>
            These documents are consistent with SEC regulatory requirements and
            provide a rich dataset for information extraction, reasoning, and
            benchmarking retrieval and generation models.
          </p>
          <p style={{ color: "white" }}>
            <a
              href="https://github.com/docugami/KG-RAG-datasets/tree/main/sec-10-q/data/v1/docs"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white" }}
            >
              Dataset Source
            </a>
          </p>
        </div>
      ),
      benchmarks: (
        <div style={{ fontSize: "0.9em" }}>
          <p style={{ color: "white" }}>
            <strong>The sample questions </strong> include 5 questions selected
            from the CSV file &nbsp;
            <a
              href="https://github.com/docugami/KG-RAG-datasets/blob/main/sec-10-q/data/v1/qna_data.csv"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white" }}
            >
              <code>qna_data.csv</code>
            </a>
            &nbsp; related to Apple Inc.
          </p>

          <p>Each entry includes:</p>
          <ul>
            <li>A question</li>
            <li>The corresponding answer</li>
          </ul>
          <p>
            This structured format facilitates the evaluation of retrieval and
            generation models by providing a clear mapping between queries and
            expected responses.
          </p>
        </div>
      ),
    },
  ];

  // preview control functions
  const handleOpen = (index) => {
    // find template from templates where bot_id matches
    const bot_id = items[index].bot_id;
    const matchingTemplate = templates.find(
      (template) => template._id["$oid"] === bot_id
    );
    if (matchingTemplate && index !== -1) {
      const {
        title,
        description,
        overview,
        retrieval,
        generation,
        dataset,
        benchmarks,
      } = items[index];
      Object.assign(matchingTemplate, {
        title,
        description,
        overview,
        retrieval,
        generation,
        dataset,
        benchmarks,
      });
      setPreviewData(matchingTemplate ? matchingTemplate : null);
      setOpen(true);
    } else {
      showSnackbar("Error: No matching template or item found", "error");
    }
  };
  const handleClose = () => setOpen(false);
  const handleTabChange = (event, newValue) => setTabIndex(newValue);

  // Open snackbar with a message and severity
  const showSnackbar = (message, severity = "info") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // Close snackbar
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSelectTemplates = (index) => {
    showSnackbar(`Selected template: ${items[index].title}`, "info");
    // find template from templates where bot_id matches
    const bot_id = items[index].bot_id;
    const matchingTemplate = templates.find(
      (template) => template._id["$oid"] === bot_id
    );
    if (matchingTemplate && index !== -1) {
      setSelectedTemplate(matchingTemplate ? matchingTemplate : null);

      setNodeCount(0);
      setElements(initialNodes);
    } else {
      console.log("No matching template or item found");
    }

    // update setdata here
    navigate("/dashboard/createChatbot");
    setTabName("createChatbot");
  };
  // from chatwindow
  function humanizeBotName(botName) {
    const match = botName?.match(
      /^(.+?)_(\d{4})(\d{2})(\d{2})_(\d{2})(\d{2})(\d{2})$/
    );
    if (!match) return botName || "";

    const [, filename, year, month, day, hour, minute, second] = match;
    const date = new Date(+year, +month - 1, +day, +hour, +minute, +second);

    // e.g. "May 6, 2025 11:55:06"
    const formatted = date.toLocaleString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${filename} (${formatted})`;
  }

  return (
    <Container sx={{ ...templateContainerStyles, ...scrollbarStyles }}>
      {/* <Button onClick={() => console.log(Bot, "\n", retrievalCombinations)}>
        Check
      </Button> */}

      <Box
        sx={{
          borderColor: "divider",
          width: "100%",
          flexDirection: "row",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChangeTemplate}
          textColor="inherit"
          indicatorColor="primary"
          aria-label="Templates and Chat Window Tabs"
          sx={{
            ...tabsStyle,
            flexWrap: "nowrap", // Prevent wrapping of tabs
            ".MuiTab-root": {
              whiteSpace: "nowrap", // Ensures the text doesn't wrap
            },
          }}
        >
          <Tab label="Quick Start" />
          <Tab label="Templates" />
          <Tab label="Customize LLM App" />
        </Tabs>
      </Box>

      {tabValue === 0 && !(Object.keys(Bot).length === 0) && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {!showFileUploadArea && (
            <Tooltip
              title={
                chatbot.isLoading ||
                loading ||
                laodingDelete ||
                loadingGetData ||
                Bot.initialised === "initialising"
                  ? "Please wait application is still processing."
                  : "Create a new application"
              }
            >
              <span>
                <Button
                  variant="text"
                  disabled={
                    chatbot.isLoading ||
                    loading ||
                    laodingDelete ||
                    loadingGetData ||
                    Bot.initialised === "initialising"
                  }
                  onClick={() => {
                    setShowFileUploadArea((prev) => !prev);
                    setBot({});
                    setBotData({
                      organization: "",
                      creator: "",
                      name: "First application",
                      problem_statement: "I want a helpful assistant.",
                      "llm-finetuning": false,
                      datasets: [],
                      structured_datasets: [],
                      text2nosql: false,
                      "text2nosql-vectorsearch": true,
                      text2nosql_prompt: {
                        TEXT_TO_NO_SQL_PROMPT: TEXT_TO_NO_SQL_PROMPT,
                      },
                      aggregation_prompt: AGGRESSION_PROMPT,
                      finetuning_dataset: [],
                      dynamicShot_dataset: [],
                      rqa_prompt: `You are a helpful assistant.`,
                      prompt_combinations: {
                        "zero-shot": "You are a helpful assistant.",
                      },
                      keys: {},
                      golden_responses: [],
                      golden_responses_option: "generateQna",
                      num_of_qa_pairs: 5,
                      optimization_method: "grid-search",
                      have_memory: true,
                      response_length: {
                        "detailed-answers": false,
                        concise: false,
                        "no-preference": true,
                      },
                      response_length_text: "",
                      recency: false,
                      recency_text: "",
                      tone: {
                        formal: false,
                        informal: false,
                        "no-preference": true,
                      },
                      tone_text: "",
                      latency: { critical: true, noCritical: false },
                      references: false,
                      references_text: "",
                      sources: true,
                      sources_text:
                        "\nReturn sources of the documents used in context.",
                      metadata_filtering_sub: {
                        "all-document-types": false,
                        "one-document-type": true,
                      },
                      metadata_filtering_categories: {
                        "all-equal": true,
                        "not-equal": false,
                      },
                      metadata_categories: [],
                      structured_file: null,
                      columnTypes: {},
                      metadataDescription: {},
                      workflow: {
                        retrieval_1: {
                          chunksize: {
                            300: true,
                            700: false,
                            1800: true,
                            4200: false,
                          },
                          metric: {
                            cosine: true,
                            dotproduct: false,
                            euclidean: false,
                            hybrid: false,
                          },
                          retrieval_method: {
                            basic: true,
                            "multi-query": false,
                            hyde: false,
                            "complex-to-simple-query": false,
                            "sentence-window": true,
                            "graphrag+basic": false,
                            "graphrag+sentence-window": false,
                            "graphrag+context_retrieval": false,

                            "graphrag+context_retrieval": false,
                            "graphrag+sentence-window": false,

                            context_retrieval: false,
                          },
                          rerank_method: {
                            none: true,
                            mmr: false,
                            cohere: false,
                            llm_rerank: false,
                            pinecone: false,
                            jina: false,
                            nvidia: false,
                            contextualai: false,
                            llamarank: false,
                          },
                          top_k: {
                            1: false,
                            5: true,
                            10: true,
                            15: false,
                            20: false,
                            25: false,
                            30: false,
                            35: false,
                            40: false,
                          },
                          embedding_model: {
                            "text-embedding-ada-002": true,
                            "fine-tuned": false,
                            "text-embedding-3-small": false,
                            "text-embedding-3-large": false,
                            "voyage-law-2": false,
                            "voyage-finance-2": false,
                            "voyage-code-3": false,
                            "voyage-3.5": false,
                            "embed-v4.0": false,
                          },
                          parser: {
                            recursive_character_text_splitter: true,
                            unstructuredio: false,
                            llama_parse: false,
                          },
                          query_preprocess_method: {
                            basic: true,
                            multi_query: false,
                            hyde: false,
                            complex_to_simple: false,
                            query_expansion: false,
                            iterative_deconstruction: false,
                          },
                          metadata_filtering: {
                            "add-metadata": false,
                            "no-metadata": true,
                          },
                          applications: {
                            "no-application": true,
                            slack: false,
                            telegram: false,
                            googledrive: false,
                          },
                          tools: {
                            "no-tools": true,
                            calendly: false,
                            traditionalDb: false,
                            "payment-system": false,
                          },
                          knowledgebase: {
                            "no-knowledgebase": true,
                            csv: false,
                            websites: false,
                            drive: false,
                          },
                        },
                        generation_1: {
                          finetuning_values: {
                            llm: {
                              "llama-3-8b": false,
                              "gpt-4o-mini-2024-07-18": true,
                            },
                            epoch: { 1: true },
                            learningRate: { 1: "true" },
                            batchSize: { 2: "true" },
                            optimization_method: "grid-search",
                            prompts: {
                              "zero-shot": true,
                              "few-shot": false,
                              "few-shot-random": false,
                              "dynamic-few-shot": false,
                              "chain-of-thought": false,
                              "few-shot-cot-random": false,
                            },
                          },
                          llm_params: {
                            temperature: { 0: "true" },
                            outputTokenLimit: { 0: "true" },
                            llm: {
                              "gpt-4o-mini": true,
                              "gpt-4": false,
                              "gpt-4o": false,
                              "meta-llama/Meta-Llama-3-8B-Instruct-Turbo": false,
                              "meta-llama/Meta-Llama-3.1-8B-Instruct-Turbo": false,
                              "meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo": false,
                              "meta-llama/Llama-3.2-11B-Vision-Instruct-Turbo": false,
                              "meta-llama/Llama-3.2-90B-Vision-Instruct-Turbo": false,
                              "meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8": false,
                              "meta-llama/Llama-4-Scout-17B-16E-Instruct": false,
                              "claude-3-opus-20240229": false,
                              "claude-3-sonnet-20240229": false,
                              "claude-3-haiku-20240307": false,
                              "claude-3-5-sonnet-20241022": false,
                              "gemini-1.5-pro": false,
                              "gemini-1.5-flash": false,
                              "gemini-1.0-pro": false,
                              "gemini-2.5-flash-preview-05-20": false,
                              "mistralai/Mixtral-8x22B-Instruct-v0.1": false,
                              "mistralai/Mixtral-8x7B-Instruct-v0.1": false,
                              "claude-sonnet-4-20250514": false,
                              "claude-opus-4-20250514": false,
                              o1: false,
                              "o1-mini": false,
                              "gpt-4.1-2025-04-14": false,
                              "gpt-4.1-mini-2025-04-14": false,
                              "gpt-4.1-nano-2025-04-14": false,
                              "gemini-1.5-flash-8b": false,
                              "meta-llama/Llama-3.3-70B-Instruct-Turbo": false,
                              "deepseek-ai/DeepSeek-V3": false,
                              "deepseek-ai/deepseek-llm-67b-chat": false,
                              "grok-3-latest": false,
                              "grok-3-fast-latest": false,
                              "grok-3-mini-latest": false,
                              "grok-3-mini-fast-latest": false,
                              "Qwen/Qwen3-235B-A22B-fp8-tput": false,
                            },
                            prompts: {
                              "zero-shot": true,
                              "few-shot": false,
                              "few-shot-random": false,
                              "dynamic-few-shot": false,
                              "chain-of-thought": false,
                              "few-shot-cot-random": false,
                            },
                          },
                        },
                      },
                      headers: [],
                      foundational: true,
                      unstructuredColumnTypes: {},
                      neo4j_credentials: {
                        NEO4J_URI: "",
                        NEO4J_USERNAME: "",
                        NEO4J_PASSWORD: "",
                        llm: "",
                      },
                      neo_4j_prompts: {
                        KG_TRIPLET_EXTRACT_TMPL: KG_TRIPLET_EXTRACT_TMPL,
                      },
                      retrieval_prompts: {
                        contextual_retrieval_prompt: "",
                        chunk_window_size: "2",
                      },
                      query_preprocessing_prompts: {
                        retrieval_1: {
                          complex_to_simple: COMPLEX_TO_SIMPLE_QUERY_PROMPT,
                          query_expansion: QUERY_EXPANSION,
                          multi_query: MULTI_QUERY_PROMPT,
                          hyde: HYDE_PROMPT,
                          iterative_deconstruction: ITERATIVE_DECONSTRUCTION,
                        },
                      },
                      parsing_instructions: {
                        llama_parse_prompt: LLAMA_PARSE_PROMPT,
                        llama_parse_mode: {
                          accurate: false,
                          premium: false,
                          continuous: false,
                          third_party_multimodal: false,
                          auto: true,
                        },
                        third_party_multimodal_llm: {
                          llm: "",
                        },
                        exclude_title_page: false,
                        bounding_box: "0,0,0,0",
                        title_page_number: "1",
                        unstructuredio_mode: {
                          fast: false,
                          hi_res: false,
                          auto: true,
                          ocr_only: false,
                        },
                      },
                    });
                    setOptimizedRag({});
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                    backgroundColor: "transparent",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "13px",
                    textTransform: "none",
                    padding: "0px",
                    border: "none",
                    outline: "none",
                    boxShadow: "none",
                    width: "30px",
                    minWidth: "30px",
                    "&.hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <AddCircleIcon fontSize="medium" />
                </Button>
              </span>
            </Tooltip>
          )}
          <div>
            {!loading &&
            !showFileUploadArea &&
            Bot &&
            (Bot.initialised === "initialising" ||
              Bot.initialised === "not started") ? (
              <>
                <Typography
                  sx={{
                    backgroundColor: "#2C2F3E",
                    padding: "8px 14px",
                    borderRadius: "5px",
                  }}
                >
                  Application "<strong>{Bot?.name}"</strong> setup is in
                  progress. Please wait.
                </Typography>
              </>
            ) : !loading &&
              Bot &&
              Bot?.combinations?.length === 1 &&
              Bot.initialised === "unsuccessful" ? (
              <>
                {" "}
                <Typography
                  sx={{
                    backgroundColor: "#2C2F3E",
                    padding: "8px 14px",
                    borderRadius: "5px",
                  }}
                >
                  Application "<strong>{Bot?.name}"</strong> setup has failed.
                  Please delete this application from below and try again.
                </Typography>
              </>
            ) : (
              !loading &&
              Bot &&
              (Bot.initialised === "initialising" ||
                Bot.initialised === "not started") && (
                <>
                  {" "}
                  <Typography
                    sx={{
                      backgroundColor: "#2C2F3E",
                      padding: "8px 14px",
                      borderRadius: "5px",
                    }}
                  >
                    Application "<strong>{Bot?.name}"</strong> setup is in
                    progress. Reload the page in few minutes to check the
                    status.
                  </Typography>
                </>
              )
            )}
          </div>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              width: "100%",
            }}
          >
            {!loading &&
            !chatbot?.isLoading &&
            Bot?.default_flow?.[1]?.retrieval ? (
              <Tooltip title={"Application is deployed."} placement="right">
                <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                  <StatusDot online={true} />
                </Box>
              </Tooltip>
            ) : (
              !loading &&
              !chatbot?.isLoading && (
                <Tooltip
                  title={"Application is not deployed."}
                  placement="right"
                >
                  <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                    <StatusDot online={false} />
                  </Box>
                </Tooltip>
              )
            )}
            {!loading && !chatbot?.isLoading && (
              <Tooltip
                title={
                  humanizeBotName(Bot?.name) +
                  `${
                    Bot?.default_flow?.[1]?.retrieval
                      ? " (Deployed)"
                      : " (Not deployed)"
                  }
                 `
                }
                placement="right"
              >
                <Typography
                  variant="h4"
                  sx={{
                    mt: 1,
                    fontSize: createLLMTypography.fontSizes.sectionText1,
                    textAlign: "center",
                  }}
                >
                  {Bot?.name
                    ? humanizeBotName(Bot?.name).length > 40
                      ? humanizeBotName(Bot?.name).slice(0, 40) + "..."
                      : humanizeBotName(Bot?.name)
                    : "Unnamed Bot"}
                </Typography>
              </Tooltip>
            )}
          </Box>
        </Box>
      )}

      {!loading &&
        !loadingGetData &&
        !chatbot?.isLoading &&
        showFileUploadArea &&
        tabValue === 0 &&
        !(Object.keys(Bot).length === 0) && (
          <div
            className="dashboard-chatoverdata"
            style={{
              padding: "0px 0px 10px 0px",

              borderLeft: `1px solid ${theme.border.light}`,
              borderRight: `1px solid ${theme.border.light}`,
            }}
          >
            <Typography
              variant="p"
              sx={{
                fontSize: "14px",
                padding: "10px",
                backgroundColor: "#3C3F51",
                color: "#fff",
              }}
            >
              Start by creating a standard, slightly optimized LLM application.
              For Pro and Enterprise users, Queryloop will gather
              use-case-specific information to automatically optimize your app's
              responses. Note: Memory is not included in this quick-start
              application, but you can add it later at any time.
            </Typography>

            <Typography variant="h6" sx={{ padding: "10px 20px" }}>
              {showQuestionnaire
                ? `Please answer the following questions`
                : `Chat over data`}
            </Typography>

            <Box sx={dashboarStyles}>
              <FileUploadArea
                // drag & drop state
                isDragging={isDragging}
                setIsDragging={setIsDragging}
                // dataset state
                datasets={datasets}
                setDatasets={setDatasets}
                // loading flags
                loading={loading}
                setLoading={setLoading}
                loadingMessage={loadingMessage}
                setLoadingMessage={setLoadingMessage}
                // bot & RAG state
                bot={Bot}
                setBot={setBot}
                botData={botData}
                setBotData={setBotData}
                // combination IDs
                setRetrievalCombinationId={setRetrievalCombinationId}
                setRetrievalCombinationId2={setRetrievalCombinationId2}
                setGenerationCombinationId={setGenerationCombinationId}
                setGenerationCombinationId2={setGenerationCombinationId2}
                setRetrievalCombinations={setRetrievalCombinations}
                retrievalCombinations={retrievalCombinations}
                // optimization state
                optimizedRag={optimizedRag}
                setOptimizedRag={setOptimizedRag}
                // questionnaire state
                showQuestionnaire={showQuestionnaire}
                setShowQuestionnaire={setShowQuestionnaire}
                questionnaireStarted={questionnaireStarted}
                setQuestionnaireStarted={setQuestionnaireStarted}
                questionnaireCompleted={questionnaireCompleted}
                setQuestionnaireCompleted={setQuestionnaireCompleted}
                currentQuestion={currentQuestion}
                setCurrentQuestion={setCurrentQuestion}
                questionnaireMessages={questionnaireMessages}
                setQuestionnaireMessages={setQuestionnaireMessages}
                // UI controls
                showSnackbar={showSnackbar}
                setShowFileUploadArea={setShowFileUploadArea}
                setShowOptimizationMessage={setShowOptimizationMessage}
                // render mode
                render_method="normal"
              />
            </Box>
          </div>
        )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {/* preview templates */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            width: "100%",
            height: "60vh",
            padding: "20px",
            fontFamily: "var(--font-primary)",
            backgroundColor: "var(--colorPrimary)", // Use your variable for background
            color: colors.extremeWhite, // Text color
          },
        }}
      >
        <DialogActions
          sx={{
            justifyContent: "flex-end",
            width: "100%",
            px: 2,
          }}
        >
          {" "}
          <IconButton edge="end" color="inherit" onClick={handleClose}>
            <Close />
          </IconButton>
        </DialogActions>
        <DialogTitle>{previewData?.title}</DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            height: "100%", // Ensure content uses full height of dialog
            width: "100%", // Ensure full width
            overflow: "hidden", // Prevent overflow outside the dialog
          }}
        >
          {/* Vertical Tabs */}
          <Tabs
            orientation="vertical"
            value={tabIndex}
            onChange={handleTabChange}
            sx={{
              borderRight: 1,
              borderColor: "divider",
              width: "200px", // Fixed width of vertical tabs
              flexShrink: 0, // Prevent tabs from resizing
              color: colors.extremeWhite,
            }}
          >
            <Tab
              label="Overview"
              sx={{
                color: colors.extremeWhite,
                textTransform: "none",
                width: "100%", // Ensure tab spans full width
              }}
            />

            {previewData?.benchmarks && (
              <Tab
                label="Sample QnAs"
                sx={{
                  color: colors.extremeWhite,
                  textTransform: "none",
                  width: "100%",
                }}
              />
            )}
            {previewData?.dataset && (
              <Tab
                label="Datasets"
                sx={{
                  color: colors.extremeWhite,
                  textTransform: "none",
                  width: "100%",
                }}
              />
            )}
            {previewData?.combination_settings && (
              <Tab
                label="Retrieval Settings"
                sx={{
                  color: colors.extremeWhite,
                  textTransform: "none",
                  width: "100%",
                }}
              />
            )}
            {previewData?.generation_settings?.llm_params && (
              <Tab
                label="Generation Settings"
                sx={{
                  color: colors.extremeWhite,
                  textTransform: "none",
                  width: "100%",
                }}
              />
            )}
            {previewData?.finetune && (
              <Tab
                label="Finetuning Settings"
                sx={{
                  color: colors.extremeWhite,
                  textTransform: "none",
                  width: "100%",
                }}
              />
            )}
          </Tabs>

          {/* Tab Content */}
          <Box
            sx={{
              p: 3,
              flexGrow: 1,
              overflowY: "auto",
              WebkitOverflowScrolling: "touch", // For smooth scrolling on iOS
              scrollbarWidth: "thin", // For Firefox
              scrollbarColor: `${colors.secondaryBlue} ${colors.extremeBlack}`, // Custom scrollbar thumb and track colors
              "&::-webkit-scrollbar": {
                width: "8px", // Custom scrollbar width
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: colors.secondaryBlue, // Custom scrollbar thumb color
                borderRadius: "10px", // Rounding scrollbar edges
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: colors.extremeBlack, // Track background color
                borderRadius: "10px", // Round track edges for consistency
              },
            }}
          >
            {tabIndex === 0 && <Box>{previewData?.overview}</Box>}
            {tabIndex === 1 && <Box>{previewData?.benchmarks}</Box>}
            {tabIndex === 2 && <Box>{previewData?.dataset}</Box>}
            {tabIndex === 3 && <Box>{previewData?.retrieval}</Box>}
            {tabIndex === 4 && <Box>{previewData?.generation}</Box>}
            {previewData?.finetune && tabIndex === 5 && (
              <Box>{previewData?.finetune}</Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>
      <Box sx={templatePaperStyles}>
        {loading && tabValue === 0 ? (
          <Box className="loader_" sx={loaderStyles}>
            {/* CircularProgress spinner */}
            <CircularProgress
              size={40}
              thickness={4}
              sx={{ color: "var(--buttonBackground)", marginRight: 2 }}
            />
            <Typography sx={{ color: "#fff" }}>
              {loadingMessage} Please wait and stay on this page.
            </Typography>
          </Box>
        ) : loadingGetData && tabValue === 0 ? (
          <Box className="loader_" sx={loaderStyles}>
            {/* CircularProgress spinner */}
            <CircularProgress
              size={40}
              thickness={4}
              sx={{ color: "var(--buttonBackground)", marginRight: 2 }}
            />
            <Typography sx={{ color: "#fff" }}>
              Fetching applications. Please wait.
            </Typography>
          </Box>
        ) : !chatbot?.isLoading &&
          !loading &&
          tabValue === 0 &&
          Object.keys(Bot).length === 0 ? (
          // Show FileUploadArea when no datasets are uploaded
          <div
            className="dashboard-chatoverdata"
            style={{
              borderBottom: `1px solid ${theme.border.light}`,
              padding: "0px 0px 10px 0px",
            }}
          >
            <Typography
              variant="p"
              sx={{
                fontSize: "14px",
                padding: "10px",
                backgroundColor: "#3C3F51",
                color: "#fff",
                marginTop: "0px",
              }}
            >
              Start by creating a standard, slightly optimized LLM application.
              For Pro and Enterprise users, Queryloop will gather
              use-case-specific information to automatically optimize your app's
              responses. Note: Memory is not included in this quick-start
              application, but you can add it later at any time.
            </Typography>
            <Typography variant="h6" sx={{ padding: "10px 20px" }}>
              {showQuestionnaire
                ? `Please answer the following questions`
                : `Chat over data`}
            </Typography>

            <Box sx={dashboarStyles}>
              <FileUploadArea
                // drag & drop state
                isDragging={isDragging}
                setIsDragging={setIsDragging}
                // dataset state
                datasets={datasets}
                setDatasets={setDatasets}
                // loading flags
                loading={loading}
                setLoading={setLoading}
                loadingMessage={loadingMessage}
                setLoadingMessage={setLoadingMessage}
                // bot & RAG state
                bot={Bot}
                setBot={setBot}
                botData={botData}
                setBotData={setBotData}
                // combination IDs
                setRetrievalCombinationId={setRetrievalCombinationId}
                setRetrievalCombinationId2={setRetrievalCombinationId2}
                setGenerationCombinationId={setGenerationCombinationId}
                setGenerationCombinationId2={setGenerationCombinationId2}
                setRetrievalCombinations={setRetrievalCombinations}
                retrievalCombinations={retrievalCombinations}
                // optimization state
                optimizedRag={optimizedRag}
                setOptimizedRag={setOptimizedRag}
                // questionnaire state
                showQuestionnaire={showQuestionnaire}
                setShowQuestionnaire={setShowQuestionnaire}
                questionnaireStarted={questionnaireStarted}
                setQuestionnaireStarted={setQuestionnaireStarted}
                questionnaireCompleted={questionnaireCompleted}
                setQuestionnaireCompleted={setQuestionnaireCompleted}
                currentQuestion={currentQuestion}
                setCurrentQuestion={setCurrentQuestion}
                questionnaireMessages={questionnaireMessages}
                setQuestionnaireMessages={setQuestionnaireMessages}
                // UI controls
                showSnackbar={showSnackbar}
                setShowFileUploadArea={setShowFileUploadArea}
                setShowOptimizationMessage={setShowOptimizationMessage}
                // render mode
                render_method="normal"
              />
            </Box>
          </div>
        ) : (
          !showFileUploadArea &&
          tabValue === 0 && (
            // Show ChatWindow when files are uploaded
            <ChatWindow
              setTabName={setTabName}
              datasets={datasets}
              retrievalCombinationId={retrievalCombinationId}
              generationCombinationId={generationCombinationId}
              setRetrievalCombinationId={setRetrievalCombinationId}
              setGenerationCombinationId={setGenerationCombinationId}
              retrievalCombinationId2={retrievalCombinationId2}
              generationCombinationId2={generationCombinationId2}
              setRetrievalCombinationId2={setRetrievalCombinationId2}
              setGenerationCombinationId2={setGenerationCombinationId2}
              bot={Bot}
              setBot={setBot}
              botData={botData}
              setBotData={setBotData}
              retrievalCombinations={retrievalCombinations}
              setRetrievalCombinations={setRetrievalCombinations}
              setShowQuestionnaire={setShowQuestionnaire}
              setShowOptimizationMessage={setShowOptimizationMessage}
              setCurrentQuestion={setCurrentQuestion}
              setQuestionnaireMessages={setQuestionnaireMessages}
              setQuestionnaireStarted={setQuestionnaireStarted}
              setQuestionnaireCompleted={setQuestionnaireCompleted}
              showQuestionnaire={showQuestionnaire}
              showOptimizationMessage={showOptimizationMessage}
              questionnaireMessages={questionnaireMessages}
              currentQuestion={currentQuestion}
              questionnaireStarted={questionnaireStarted}
              questionnaireCompleted={questionnaireCompleted}
              handleOptimizeNow={handleOptimizeNow}
              handleOptimizeFurther={handleOptimizeFurther}
              optimizedRag={optimizedRag}
              setOptimizedRag={setOptimizedRag}
            />
          )
        )}

        {tabValue === 0 && (
          <Box
            padding={4}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "20",
              flexWrap: "wrap",
              width: "100%",
              borderTop: `1px solid ${theme.border.light}`,
              rowGap: "10px",
              columnGap: "10px",
              minHeight: "100px",
              height: { xs: "20%", md: "auto" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                width: "100%",
                marginBottom: "20px",
              }}
            >
              <Typography fontSize={30}>
                Applications{" "}
                {`(${organization?.organization?.templates?.length || 0})`}
              </Typography>
            </Box>
            {tabValue === 0 &&
            chatbot?.templateBots?.combinations?.length > 0 &&
            !loading ? (
              [...chatbot.templateBots.combinations]
                .reverse()
                .map((app, index) => (
                  <ApplocationsCard
                    setGenerationCombinationId2={setGenerationCombinationId2}
                    setRetrievalCombinationId2={setRetrievalCombinationId2}
                    loadingDelete={laodingDelete}
                    setLoadingDelete={setLoadingDelete}
                    handleDelete={handleDelete}
                    key={app?._id["$oid"]}
                    name={app?.name}
                    have_memory={app?.have_memory}
                    base_prompt={app?.rqa_prompt}
                    bot={Bot}
                    setBot={setBot}
                    app={app}
                    setShowFileUploadArea={setShowFileUploadArea}
                    setRetrievalCombinations={setRetrievalCombinations}
                  />
                ))
            ) : chatbot.isLoading ? (
              <Typography>Applications are loading please wait</Typography>
            ) : (
              <Typography></Typography>
            )}
          </Box>
        )}
        {/* {datasets.length === 0 && (
          <Box sx={contentGenerationOnly}>
            <Typography variant="h7">
              Content Generation Application Only?
            </Typography>
            <Button sx={{ marginLeft: "10px" }} variant="contained">
              Open Chat Now
            </Button>
          </Box>
        )} */}

        {/* Templates Display */}
        {tabValue === 1 && (
          <Box sx={{ p: 4 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="body1">
                Use these predefined templates to create an optimized LLM
                application
              </Typography>
              <Tooltip title="Create New Blank Application">
                <Button
                  sx={btnStyles}
                  onClick={() => {
                    setNodeCount(0);
                    setSelectedTemplate(null);
                    setTabName("createChatbot");
                    setData((prevData) => ({
                      ...prevData,
                      workflow: {},
                      golden_responses: [],
                    }));
                    const user = localStorage.getItem("user");
                    const token = localStorage.getItem("token");
                    localStorage.clear();
                    clearDb();
                    if (user) localStorage.setItem("user", user);
                    if (token) localStorage.setItem("token", token);
                    localStorage.removeItem("golden_responses");
                    localStorage.removeItem("chunkSize_retrieval_1");
                    localStorage.removeItem("embedding_retrieval_1");
                    localStorage.removeItem("retrievalMethod_retrieval_1");
                    localStorage.removeItem("rerank_retrieval_1");
                    localStorage.removeItem("topk_retrieval_1");
                    localStorage.removeItem("metricType_retrieval_1");
                    localStorage.removeItem("queryTransform_retrieval_1");
                    localStorage.removeItem(
                      "queryTransform_prompts_retrieval_1"
                    );
                    localStorage.removeItem("retrieval_prompts_retrieval_1");
                    localStorage.removeItem("parser_retrieval_1");
                    localStorage.removeItem("temperature_generation_2");
                    localStorage.removeItem("learningRateM_generation_2");
                    localStorage.removeItem("learningRate__generation_2");
                    localStorage.removeItem("rank_generation_2");
                    localStorage.removeItem("aplhaRankRatio_generation_2");
                    localStorage.removeItem("llm_select_generation_2");
                    localStorage.removeItem("dataset_generation_2");
                    localStorage.removeItem("LLM_generation_2");
                    localStorage.removeItem("LLMFinetuning_generation_2");
                    localStorage.removeItem("LLMFoundational_generation_2");
                    localStorage.removeItem("hidden_generation_2");
                    localStorage.removeItem("prompt_combinations_generation_2");
                    localStorage.removeItem("batchSize_generation_2");
                    localStorage.removeItem("epoch_generation_2");
                    localStorage.removeItem("opm_select_generation_2");
                    localStorage.removeItem(
                      "learningRateMultiplier_generation_2"
                    );
                    localStorage.removeItem("startLR_generation_2");
                    localStorage.removeItem("startLRM_generation_2");
                    localStorage.removeItem("endLR_generation_2");
                    localStorage.removeItem("endLRM_generation_2");
                    localStorage.removeItem("alphaRank_generation_2");
                    localStorage.removeItem("prompts_generation_2");
                    localStorage.removeItem("prompt_combinations_generation_2");
                    localStorage.removeItem("llm_prompts_generation_2");
                    localStorage.removeItem("csvData_generation_2");
                    localStorage.removeItem("dataset_generation_2");
                    const updatedNodes = initialNodes.map((node) => {
                      if (node.id === "InputNodes") {
                        return {
                          ...node,
                          data: {
                            ...node.data,
                            botData: {
                              ...node.data.botData,
                              golden_responses: [],
                              problem_statement: "I want an helpful assistant.",
                              prompt_guidelines: {
                                tone: {
                                  formal: true,
                                  informal: false,
                                  "no-preference": false,
                                },
                                response_length: {
                                  "detailed-answers": false,
                                  concise: true,
                                  "no-preference": false,
                                },
                                recency: true,
                                sources: true,
                              },
                              prompt_guides: [],
                              default_flow: {},
                              structured_datasets: [],
                              csvData: {},
                              unstructuredColumnTypes: {},
                              column_types: {},
                              prompt_combinations: {
                                "zero-shot": 'You are a helpful assistant.\n""',
                              },
                              LLMFinetuning: false,
                              have_memory: true,
                              datasets: [],
                              finetuning_dataset: {},
                              workflow: {},
                              query_preprocessing_prompts: {},
                            },
                          },
                        };
                      }
                      // Leave other nodes as-is
                      return node;
                    });
                    setElements(updatedNodes);
                    navigate(`/dashboard/createChatbot`);
                  }}
                >
                  + Create New
                </Button>
              </Tooltip>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 3,
                justifyContent: "center",
                py: 2,
                pt: 3,
              }}
            >
              {items?.reverse().map((item, index) => (
                <Card key={index} sx={templateCardStyles}>
                  <CardContent sx={{ textAlign: "start", padding: 3 }}>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography variant="h6" gutterBottom>
                        {item.title}
                      </Typography>
                      <Tooltip title={"View configuration"}>
                        <IconButton
                          sx={{
                            ...iconButtonActive,
                            backgroundColor: "none",
                            "&:hover": {
                              backgroundColor: "none",
                              color: theme.textColors.dark.secondary,
                            },
                          }}
                          onClick={() => handleOpen(index)}
                        >
                          <InfoOutlined />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    {/* Template Summary */}
                    <Typography variant="body2" sx={{ marginBottom: 2 }}>
                      {item.description.summary}
                    </Typography>

                    {/* settings List */}
                    <List dense>
                      {item.description.parameters.map((param, idx) => (
                        <ListItem key={idx} sx={{ py: 0 }}>
                          <ListItemIcon>
                            {param.status ? (
                              <CheckCircle sx={{ color: "white" }} />
                            ) : (
                              <Cancel sx={{ color: "white" }} />
                            )}
                          </ListItemIcon>
                          <ListItemText
                            variant="caption"
                            primary={param.name}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                  <CardActions>
                    <Button
                      sx={{ ...btnStyles, bgcolor: "#6A6AFF" }}
                      onClick={() => handleSelectTemplates(index)}
                    >
                      Use Template
                    </Button>
                  </CardActions>
                </Card>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default Templates;
